import React, { useState } from 'react';
import { Box, Container, ThemeProvider } from '@mui/material';
import LandingPage from '../landingPage';
import {
  SmartFeedDashboard,
  smartFeedTheme,
  SubscriptionProvider,
  LifeIntelligenceBar,
  UpcomingDeadlinesPanel,
} from '../../Components/SmartFeed';
import HomeToggleHeader from '../../Components/HomeToggleHeader';

const DEFAULT_HOME_VIEW = 'smartfeed';

const HomePage = () => {
  const [view, setView] = useState(DEFAULT_HOME_VIEW);

  // Subscription: fully driven by DB. Users without a subscription (has_subscription false from
  // /api/user/user/) are blocked at App level and never reach HomePage. Users with a subscription
  // are not shown any popup here; they can use NavBar → Abonnement (/subscription) to change plan.

  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: view === 'smartfeed' ? '#0b0e1a' : '#00001d' }}>
      <HomeToggleHeader view={view} onViewChange={handleViewChange} />
      
      <Box sx={{ position: 'relative' }}>
        {view === 'classic' ? (
          <LandingPage />
        ) : (
          <ThemeProvider theme={smartFeedTheme}>
            <SubscriptionProvider>
              {/* LAP — Life Intelligence au-dessus du feed + colonne droite
                  « échéances à venir » (demande Alexis, style SAP Ariba :
                  contenu complémentaire à droite). Colonne masquée sous
                  `lg` pour ne pas écraser le feed sur tablette/mobile. */}
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 3 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Container maxWidth="xl" sx={{ pt: 3, pb: 0 }}>
                    <LifeIntelligenceBar />
                  </Container>
                  <SmartFeedDashboard />
                </Box>

                <Box
                  sx={{
                    width: 320,
                    flexShrink: 0,
                    display: { xs: 'none', lg: 'block' },
                    position: 'sticky',
                    top: 24,
                    mt: 3,
                    mr: 3,
                  }}
                >
                  <UpcomingDeadlinesPanel />
                </Box>
              </Box>
            </SubscriptionProvider>
          </ThemeProvider>
        )}
      </Box>
    </Box>
  );
};

export default HomePage;
